var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.582 16.352h-1.174l-.417-.401a9.62 9.62 0 002.334-6.288A9.662 9.662 0 009.663 0 9.662 9.662 0 000 9.663a9.662 9.662 0 009.663 9.662 9.62 9.62 0 006.288-2.334l.401.417v1.174L23.785 26 26 23.785l-7.418-7.433zM9.5 16A6.491 6.491 0 013 9.5C3 5.903 5.903 3 9.5 3S16 5.903 16 9.5 13.097 16 9.5 16z","fill":"#E1E4E8","fillRule":"nonzero"}));
}

Search.defaultProps = {"width":"26","height":"26"};

module.exports = Search;

Search.default = Search;
